import React from 'react';

const Authenticate = React.lazy(
    () => import('../../modules/auth/Authenticate/index'),
);
export const authRouteConfig = [
    {
        path: '/authenticate',
        element: <Authenticate />,
    },
];
